import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=664b8cdc&"
import script from "./OrderInfo.vue?vue&type=script&lang=babel&"
export * from "./OrderInfo.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports